

let eventSource = null;
const listeners = new Set();
let reconnectTimeout = null;
let reconnectDelay = 5000;
let currentUrl = '';



export function initSSE(url) {
  if (eventSource) return;
  currentUrl = url;

  connect();
}

function connect() {
  if (!currentUrl) return;

  eventSource = new EventSource(currentUrl);

  eventSource.onopen = () => {
    console.info('SSE: connected');
    clearTimeout(reconnectTimeout);
  };

  eventSource.onerror = (err) => {
    console.error('SSE error', err);


    if (eventSource.readyState === EventSource.CLOSED || eventSource.readyState === EventSource.CONNECTING) {
      eventSource.close();
      eventSource = null;

      reconnectTimeout = setTimeout(() => {
        console.warn('SSE: reconnecting');
        connect();
      }, reconnectDelay);
    }
  };

  eventSource.addEventListener('statusChange', (e) => {
    let payload;
    try {
      payload = JSON.parse(e.data);
    } catch (err) {
      console.error('📛 SSE JSON parse error', err, e.data);
      return;
    }

    listeners.forEach(cb => cb(payload));
  });
}


/**
 * Подписаться на обновления.
 * @param {(payload: any)=>void} callback
 * @returns {()=>void} — отписка
 */
export function subscribeToSSE(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}


export function closeSSE() {
  if (eventSource) {
    console.info('🔌 SSE: connection closed');
    eventSource.close();
    eventSource = null;
  }

  clearTimeout(reconnectTimeout);
  reconnectTimeout = null;
  listeners.clear();
}
